import { gsap } from 'gsap'

export default class ExcelsiorAnimationCueController {
    
    constructor(animTweenRef) {
        this.animTweenRef = animTweenRef;
    }

    shakeScreen(layerRef, amt) {
        if (this.animTweenRef.current && this.animTweenRef.current.isActive()){return}

        const x = layerRef.attrs.x
        const random = Math.floor(Math.random() * 2);
        this.animTweenRef.current = gsap.to(layerRef, {
            duration: .01,
            x: () => random === 0 ? gsap.utils.random(layerRef.attrs.x - 20, layerRef.attrs.x - 10, 1) : gsap.utils.random(layerRef.attrs.x + 20, layerRef.attrs.x + 10, 1),
            ease: "power1.inOut",
            yoyo: true,
            repeat:20 * amt,
            onComplete: () => {
                gsap.set(layerRef, {x:x})
            }
        })
    }

   shiverScreen (layerRef, rect, rectScale) {
        if (this.animTweenRef.current && this.animTweenRef.current.isActive()){return}

        const x = layerRef.attrs.x
        const y = layerRef.attrs.y
        const scale = layerRef.attrs.scaleY
        const empAmount = 0.01

        this.animTweenRef.current = gsap.to(layerRef, {
            duration: 0.1, 
            x: () => x - ((rect.width * .75) / rectScale * empAmount ),
            y: () => y - ((rect.height/2) / rectScale * empAmount ),
            scaleY: () => scale + empAmount * 1.5,
            repeat:12, 
            ease:"power2.inOut",
            onComplete: () => {
                gsap.set(layerRef, {x:x, y:y, scaleY: scale})
            }
        })
    }

    emphasisScreen (layerRef, rect, rectScale, duration=.01) {
              
        if (this.animTweenRef.current && this.animTweenRef.current.isActive()){return}


        const x = layerRef.attrs.x
        const y = layerRef.attrs.y
        const scale = layerRef.attrs.scaleX
        const empAmount = 0.1

        this.animTweenRef.current = gsap.to(layerRef, {
            duration: duration,
            scaleX: () => scale + empAmount,
            scaleY: () => scale + empAmount,
            x: () => x - ((rect.width/2) /rectScale * empAmount ),
            y: () => y - ((rect.height/2) / rectScale * empAmount ),
            ease: "expo.inOut",
            yoyo: true,
            repeat:0,
            
            onComplete: () => {
                
                this.animTweenRef.current.kill()
                this.animTweenRef.current = gsap.to(layerRef, {
                    scaleX:scale, scaleY:scale, x:0, y:0, ease: "back.out",
                    onComplete: () => {
                        gsap.set(layerRef, {scaleX:scale, scaleY:scale, x:0, y:0})
                    }
                })
            }
          })

    }

    plopScreen (layerRef, rect, rectScale, duration=.01) {

        if (this.animTweenRef.current && this.animTweenRef.current.isActive()){return}


        // const x = layerRef.attrs.x
        const y = layerRef.attrs.y
        const scale = layerRef.attrs.scaleX
        const empAmount = 0.1

        this.animTweenRef.current = gsap.to(layerRef, {
            duration: duration,
            scaleY: () => scale + empAmount,
            y: () => y - ((rect.height) / rectScale * empAmount ),
            ease: "elastic.inOut",
            yoyo: true,
            repeat:0,
            
            onComplete: () => {
                this.animTweenRef.current.kill()
                this.animTweenRef.current = gsap.to(layerRef, {
                   scaleY:scale, y:0, ease: "back.out",
                    onComplete: () => {
                        gsap.set(layerRef, {scaleX:scale, scaleY:scale, x:0, y:0})
                    }
                })
            }
          })

    }

    stretchScreen (layerRef, rect, rectScale, horiz=true) {

        if (this.animTweenRef.current && this.animTweenRef.current.isActive()){return}

        const x = layerRef.attrs.x
        const y = layerRef.attrs.y
        const scale = layerRef.attrs.scaleX
        const empAmount = 0.05  
    
        if(horiz){
        this.animTweenRef.current = gsap.to(layerRef, {
            duration: .6,
            scaleX: () => scale + empAmount,
            x: () => x - ((rect.width/2) / rectScale * empAmount ),
            ease: "bounce.out",
            yoyo: true,
            repeat:1,
            
            onComplete: () => {
                gsap.set(layerRef, {scaleX:scale, x:0})
            }
          })
        }else{
            this.animTweenRef.current = gsap.to(layerRef, {
                duration: .6,
                scaleY: () => scale + empAmount,
                y: () => y - ((rect.height/2) / rectScale * empAmount ),
                ease: "bounce.out",
                yoyo: true,
                repeat:1,
                
                onComplete: () => {
                    gsap.set(layerRef, {scaleY:scale, y:0})
                }
              })
        }
    
    }



}